import {Injectable} from '@angular/core';
import {MatSnackBar, MatSnackBarRef} from '@angular/material/snack-bar';
import {
  StateSnackBarComponent,
  StateSnackBarData
} from "../components/shared/state-snack-bar/state-snack-bar.component";

@Injectable({
  providedIn: 'root',
})
export class StateSnackBarService {
  constructor(private matSnackBar: MatSnackBar) {}

  public error = (options?: StateSnackBarServiceOptions): MatSnackBarRef<StateSnackBarComponent> => {
    return this.matSnackBar.openFromComponent(StateSnackBarComponent, {
      data: {
        action: options?.action,
        duration: options?.duration ?? 10000,
        icon: options?.icon || undefined,
        message: options?.message || undefined,
        subMessage: options?.subMessage || undefined,
        type: 'error',
      } as StateSnackBarData,
      duration: 0,
      panelClass: ['state-snackbar', 'state-snackbar--error'],
    });
  };

  public info = (options?: StateSnackBarServiceOptions): MatSnackBarRef<StateSnackBarComponent> => {
    return this.matSnackBar.openFromComponent(StateSnackBarComponent, {
      data: {
        action: options?.action,
        duration: options?.duration ?? 3000,
        icon: options?.icon || undefined,
        message: options?.message || undefined,
        subMessage: options?.subMessage || undefined,
        type: 'info',
      } as StateSnackBarData,
      duration: 0,
      panelClass: ['state-snackbar', 'state-snackbar--info'],
    });
  };

  public success = (options?: StateSnackBarServiceOptions): MatSnackBarRef<StateSnackBarComponent> => {
    return this.matSnackBar.openFromComponent(StateSnackBarComponent, {
      data: {
        action: options?.action,
        duration: options?.duration ?? 3000,
        icon: options?.icon || undefined,
        message: options?.message || undefined,
        subMessage: options?.subMessage || undefined,
        type: 'success',
      } as StateSnackBarData,
      duration: 0,
      panelClass: ['state-snackbar', 'state-snackbar--success'],
    });
  };
}

export interface StateSnackBarServiceOptions {
  action?: StateSnackBarData['action'];
  duration?: StateSnackBarData['duration'];
  icon?: StateSnackBarData['icon'];
  message?: StateSnackBarData['message'];
  subMessage?: StateSnackBarData['subMessage'];
}
